import { API_URL } from "../constants/url";

const triggerAnchorDownload = (href: string, filename: string) => {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.target = ""; // Removed _blank to avoid popup blocker on async download
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const getApiOrigin = (): string => {
  try {
    return new URL(API_URL).origin;
  } catch {
    return "";
  }
};

const resolveExportUrl = (url: string): string => {
  if (
    url.startsWith("http") ||
    url.startsWith("blob:") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  const origin = getApiOrigin();
  if (!origin) {
    return url;
  }

  if (url.startsWith("/")) {
    return `${origin}${url}`;
  }

  if (url.startsWith("images/") || url.startsWith("files/")) {
    return `${origin}/${url}`;
  }

  return url;
};

const isFetchableUrl = (url: string): boolean =>
  url.startsWith("http") ||
  url.startsWith("/") ||
  url.startsWith("blob:") ||
  url.startsWith("data:");

export const downloadCsv = async (
  payload: unknown,
  filename = "export.csv"
): Promise<void> => {
  const url = typeof payload === "string" ? payload.trim() : "";
  if (!url) return;

  const resolvedUrl = resolveExportUrl(url);

  // If the value is raw CSV content (not a URL), wrap it in a blob directly
  if (!isFetchableUrl(resolvedUrl)) {
    const blob = new Blob([resolvedUrl], { type: "text/csv;charset=utf-8;" });
    const blobUrl = URL.createObjectURL(blob);
    triggerAnchorDownload(blobUrl, filename);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 200);
    return;
  }

  try {
    // Fetch the file as a blob so the download attribute works for cross-origin URLs (S3, CDN)
    const response = await fetch(resolvedUrl);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    triggerAnchorDownload(blobUrl, filename);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 200);
  } catch {
    // CORS-restricted or inaccessible - open directly
    window.location.href = resolvedUrl;
  }
};
